import * as actions from './config.actions';
import { Config } from './config.interface';
import { initialConfig } from './config.model';

export function reducer(state = initialConfig, action: actions.Actions): Config {
  switch (action.type) {
    case actions.CONFIG_GET: {
      return {
        verboseLogging: action.payload.VerboseLog,
        environment: action.payload.environment,
        launchpadUrl: action.payload.launchpadUrl,
        instrumentationKey: action.payload.applicationInsightInstrumentationKey,
        fetched: true,
      };
    }

    default:
      return state;
  }
}
